module.exports = __webpack_public_path__ + "assets/normal/images/wheat_ears_top.6c9816d4.png";